/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class ValidationError extends Error {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    throwOnError() {
        if (this.hasErrors) {
            // eslint-disable-next-line no-throw-literal
            throw this;
        }
    }
}
